import React from 'react';

export default class Auth extends React.Component {
  constructor(props) {
    super(props);

    this.login = this.login.bind(this);
  }

  login() {
    window.location = this.props.loginUri;
  }

  render() {
    return (
      <div className="auth-component">
        <div className="bg-primary text-light py-5 d-flex align-items-center" style={{ position: 'relative', overflow: 'hidden', minHeight: '600px' }}>
          <img src="assets/circles.png" style={{ position: 'absolute', top: '-1%', right: '-1%', width: '35%' }} />
          <div className="container" style={{ position: 'relative' }}>
            <div>
              <a href="https://www.qlik.com" target="_blank"><img src="assets/qlik-logo.png" /></a>
            </div>
            <div className="py-7" style={{ maxWidth: '600px' }}>
              <h1>ROI Calculator</h1>
              <p>Welcome to the Qlik ROI Calculator! This ROI Calculator helps you calculate the value that an investment in Qlik will bring to an organization. The calculator uses Qlik’s powerful yet flexible out-of-the-box computational & visualization functionality to model discounted cash-flows (costs-benefits) over 5 years, calculate typical ROI measures like IRR, NPV, Payback, etc., and run scenarios, Monte Carlo simulations, and interactive presentations.</p>
              <p>To start estimating the ROI for your project, please enter a Project Name below.</p>
              {/* <button className="btn btn-primary border border-light mr-3">Apply for access</button> */}
              <button className="btn btn-primary border border-light" onClick={this.login}>Login</button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/Auth/index.js